import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  danhSachLoaiLichLamViec: [],
  danhSachLichLamViec: [],
    danhSachLoaiLichCon: [],
    chiTietLichLamViec: {},
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
